import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SidebarContent } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-common/src/ui/sidebar-content/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-common/src/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useOgTenantInfo } from '@atlassian/jira-eoc-tenant-info/src/controllers/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { Redirect } from '@atlassian/react-resource-router';

export const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-global-settings-operations-settings" */ './main'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: false,
	},
);

const AsyncSidebar = (): React.JSX.Element => {
	const isAdmin = useIsAdmin();
	const { isOpsAdmin } = useOgTenantInfo();

	const hasOperationsGeneralConfiguration = fg('operations-tenant-info-endpoint-update')
		? isAdmin || isOpsAdmin
		: isAdmin;

	if (!hasOperationsGeneralConfiguration && fg('redirect_user_to_ops_page_from_global_settings')) {
		return (
			<SidebarBoundary
				id="nav4.sidebar.global-settings.operations-settings"
				packageName="jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings"
				teamName="alexstrasza"
			>
				<Redirect to="/jira/ops/overview" />
			</SidebarBoundary>
		);
	}

	return (
		<SidebarBoundary
			id="nav4.sidebar.global-settings.operations-settings"
			packageName="jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings"
			teamName="alexstrasza"
		>
			<SidebarContent
				currentPageName="operations"
				testId="navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
			>
				<Placeholder
					name="nav4.sidebar.global-settings.operations-settings"
					fallback={<Skeleton />}
				>
					<LazySidebarContent />
				</Placeholder>
			</SidebarContent>
		</SidebarBoundary>
	);
};

export default memo(AsyncSidebar);
